import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import ButtonGroup from 'components/_atoms/ButtonGroup'
import LoadingSpinnerIcon from 'components/icons/LoadingSpinner'

import './styles.css'

function localVideoWrapper({ source, }) {
  return (
    <div className="inline-video-player-container">
      <div className="inline-video-loading-container">
        <LoadingSpinnerIcon />
      </div>
      <video autoPlay controls className="inline-video-player" src={source} />
    </div>
  )
}

class VideoPlayer extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['iframe', 'html5']).isRequired,
    source: PropTypes.string.isRequired,
    lowResSource: PropTypes.string,
    setHighResolutionDisplay: PropTypes.func,
    setLowResolutionDisplay: PropTypes.func,
    resolutionType: PropTypes.oneOf(['high', 'low']),
  }
  static defaultProps = {
    lowResSource: undefined,
    setHighResolutionDisplay: undefined,
    setLowResolutionDisplay: undefined,
    resolutionType: undefined,
  }

  render() {
    const {
      type,
      source,
      lowResSource,
      resolutionType,
      setHighResolutionDisplay,
      setLowResolutionDisplay,
    } = this.props

    if (type === 'iframe') {
      return (
        <iframe
          title="video"
          src={source}
          width="640"
          height="360"
          frameBorder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowFullScreen
        />
      )
    }

    if (type === 'html5') {
      let videoContainer,
        videoSource,
        resolutionSelector

      // we only have one source so show it
      if ((source && !lowResSource) || (source && !lowResSource)) {
        videoSource = source || lowResSource
        videoContainer = localVideoWrapper({ source: videoSource, })
      } else {
        // user can choose which resolution to display
        if (resolutionType) {
          videoSource = resolutionType === 'high' ? source : lowResSource
          videoContainer = localVideoWrapper({ source: videoSource, })
        }
        const setResolutionButtonOptions = [
          {
            content: 'High Res',
            action: setHighResolutionDisplay,
            selected: !!(resolutionType === 'high'),
          },
          {
            content: 'Low Res',
            action: setLowResolutionDisplay,
            selected: !!(resolutionType === 'low'),
          },
        ]
        resolutionSelector = (
          <div className="video-resolution-selection">
            <ButtonGroup options={setResolutionButtonOptions} />
            {!resolutionType && <p>Please select a video resolution</p>}
          </div>
        )
      }

      return (
        <div>
          {videoContainer}
          {resolutionSelector}
        </div>
      )
    }

    return <div>other media</div>
  }
}

export default VideoPlayer



// WEBPACK FOOTER //
// ./src/components/_molecules/VideoPlayer/index.js